import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { getBoxGroupAllPayments } from '../../../../services/easyPay'
import { ISelectedAllPayment } from '../../../../modules/easyPay/hooks/useSetTotalPayment'

export default function useGetBoxGroupAllPayment(isAll: boolean) {
    const [payments, setPayments] = useState<Array<ISelectedAllPayment>>([])
    const [isAllSelected, setIsAllSelected] = useState<boolean>(true)
    const { id } = useParams()
    const { data, isLoading } = useQuery(
        ['get-box-all-payment', id],
        getBoxGroupAllPayments
    )
    useEffect(() => {
        if (payments.length > 0) {
            const newUnselectedPayment = payments.find(
                (item) => item.isSelected === false
            )
            if (newUnselectedPayment) {
                setIsAllSelected(false)
            } else {
                setIsAllSelected(true)
            }
        }
    }, [payments])
    useEffect(() => {
        if (data) {
            if (isAll) {
                const newData: ISelectedAllPayment[] = []
                data.map((item) => newData.push({ ...item, isSelected: true }))
                setPayments(newData)
            } else {
                if (id) {
                    const newData: ISelectedAllPayment[] = []
                    data.map((item) => {
                        if (item.box_id === Number(id)) {
                            newData.push({ ...item, isSelected: true })
                        }
                    })
                    setPayments(newData)
                }
            }
        }
    }, [data])
    const handleSelectAllPayments = () => {
        const newData: ISelectedAllPayment[] = []
        payments.map((item) =>
            newData.push({
                ...item,
                ...(isAllSelected === false
                    ? { isSelected: true }
                    : { isSelected: false }),
            })
        )
        setIsAllSelected(!isAllSelected)
        setPayments(newData)
    }
    const handleSelectSpecificPayment = (id: number) => {
        const copyPayments: ISelectedAllPayment[] = [...payments]
        copyPayments.map((item) => {
            if (item.id === id) {
                item.isSelected = !item.isSelected
            }
        })
        setPayments(copyPayments)
    }
    return {
        payments,
        isLoading,
        handleSelectAllPayments,
        isAllSelected,
        handleSelectSpecificPayment,
    }
}